import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { humanizeMealCode } from "../mealIncidenciasUtils";

const formatScalar = (value) => {
  if (value === null || value === undefined || value === "") return "Sin información";
  if (typeof value === "boolean") return value ? "Sí" : "No";
  return String(value);
};

const ReviewValue = ({ value, depth = 0 }) => {
  if (Array.isArray(value)) {
    if (value.length === 0) return <Typography variant="body2">Sin información</Typography>;
    const scalarOnly = value.every((item) => item === null || typeof item !== "object");
    if (scalarOnly) {
      return (
        <Stack direction="row" flexWrap="wrap" gap={0.75}>
          {value.map((item, index) => (
            <Chip key={`${formatScalar(item)}-${index}`} size="small" label={formatScalar(item)} variant="outlined" />
          ))}
        </Stack>
      );
    }
    return (
      <Stack spacing={1}>
        {value.map((item, index) => (
          <Box key={index} sx={{ borderLeft: "3px solid", borderColor: "divider", pl: 1.5 }}>
            <ReviewValue value={item} depth={depth + 1} />
          </Box>
        ))}
      </Stack>
    );
  }

  if (value && typeof value === "object") {
    const entries = Object.entries(value);
    if (entries.length === 0) return <Typography variant="body2">Sin información</Typography>;
    return (
      <Box display="grid" gridTemplateColumns={{ xs: "1fr", sm: depth > 1 ? "1fr" : "repeat(2, 1fr)" }} gap={1.25}>
        {entries.map(([key, child]) => (
          <Box key={key} minWidth={0}>
            <Typography variant="caption" color="text.secondary" fontWeight={800}>
              {humanizeMealCode(key)}
            </Typography>
            <ReviewValue value={child} depth={depth + 1} />
          </Box>
        ))}
      </Box>
    );
  }

  return <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>{formatScalar(value)}</Typography>;
};

const MealReviewData = ({ data }) => (
  <Box>
    {!data || (typeof data === "object" && Object.keys(data).length === 0) ? (
      <Typography variant="body2" color="text.secondary">Sin información para revisión.</Typography>
    ) : (
      <ReviewValue value={data} />
    )}
  </Box>
);

export default MealReviewData;
